import { useEffect, useState } from "react";

import { string2Time } from "../../utils/utils";

export default function useHeatpumpSgReadyTime(
  heatpump,
  setSgReadyTime,
  showMsg,
  isFocused = true,
) {
  const [selectedLowerTime, setSelectedLowerTime] = useState(null);
  const [selectedHigherTime, setSelectedHigherTime] = useState(null);

  const loadData = () => {
    setSelectedLowerTime(string2Time(heatpump.sg_ready_start_threshold));
    setSelectedHigherTime(string2Time(heatpump.sg_ready_end_threshold));
  };

  const clearData = () => {
    setSelectedLowerTime(null);
    setSelectedHigherTime(null);
  };

  const initData = loadData;

  useEffect(() => {
    if (isFocused) initData();
    else clearData();
  }, [isFocused]);

  const onSubmit = async (onSuccess) => {
    const success = await submit(selectedLowerTime, selectedHigherTime);
    success && onSuccess?.();
  };

  const submit = async (selectedLowerTime) => {
    return setSgReadyTime(selectedLowerTime, selectedHigherTime);
  };

  return {
    onSubmit,
    data: { init: initData, update: loadData, clear: clearData },
    time: {
      lower: { value: selectedLowerTime, setValue: setSelectedLowerTime },
      higher: { value: selectedHigherTime, setValue: setSelectedHigherTime },
    },
  };
}
